<app-menu-template3>
  <main class="container mb-3 bg-white mt-3 shadow-lg">
    <article class="row">
      <section class="col-3 border-right p-4 mt-5 mb-5">
        <header class="text-center mb-3">
          <label class="h5">Filtra tu consulta</label>
        </header>
        <form [formGroup]="formFiltroCertificado" (ngSubmit)="onFiltrar()">
          <div class="form-group">
            <label for="">Numero Expedicion</label>
            <input formControlName="certificado_generado_id" type="number" class="form-control form-control-sm">
          </div>
          <div class="form-group">
            <label for="">Fecha Inicial</label>
            <div class="input-group">
              <input class="form-control form-control-sm" formControlName="fechaInicio" placeholder="yyyy/mm/dd"
                [(ngModel)]="FechaIni" ngbDatepicker #ini="ngbDatepicker">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary calendar" (click)="ini.toggle()" type="button"></button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="">Fecha Final</label>
            <div class="input-group">
              <input class="form-control form-control-sm" formControlName="fechaFin" placeholder="yyyy/mm/dd"
                [(ngModel)]="FechaFin" ngbDatepicker #fin="ngbDatepicker">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary calendar" (click)="fin.toggle()" type="button"></button>
              </div>
            </div>
          </div>
          <div class="form-row mt-5">
            <button type="reset" class="btn btn-outline-primary border-0 m-auto">Limpiar</button>
            <button class="btn btn-primary m-auto solicitud-btn-principal" type="submit">Filtrar</button>
          </div>
        </form>
      </section>
      <section class="col-9 p-4 mt-5 mb-5">
        <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
        <label class="h5">Certificados Generados</label>
        <div class="table-responsive">
          <app-tablas [sizeData]="dataTabla.paging.totalItems" [headers]="headers" (paginado)="onPaginado($event)">
            <tr *ngFor="let item of dataTabla.items; let i=index">
              <td>{{item.nombre_representante_legal}}</td>
              <td>{{item.fecha_creacion | date: 'd/MMM/yyyy'}}</td>
              <td>{{item.razon_social}}</td>
              <td>{{item.certificado_generado_id}}</td>
              <td>..</td>
            </tr>
          </app-tablas>
        </div>
      </section>
    </article>
  </main>
</app-menu-template3>